export const PAGE_TITLE = 'Merchant Earnings Overview';
export const PAGE_SUBTITLE = 'Track all merchant earnings and payouts';
export const PAGE_SUBTITLE_DATE = (start: string, end: string) =>
  `${start} to ${end}`;

export const FILTER_LABELS = {
  DATE_RANGE: 'Date Range',
  SEARCH_MERCHANTS: 'Search Merchants',
  SORT_BY: 'Sort By',
  ORDER: 'Order',
} as const;

export const SORT_OPTIONS = [
  { value: 'netEarnings', label: 'Net Earnings' },
  { value: 'totalRevenue', label: 'Total Revenue' },
  { value: 'totalFees', label: 'Total Fees' },
  { value: 'orderCount', label: 'Order Count' },
] as const;

export const ORDER_OPTIONS = [
  { value: 'desc', label: 'High to Low' },
  { value: 'asc', label: 'Low to High' },
] as const;

export const TABLE_TITLE = 'Merchants Earnings Breakdown';
export const TABLE_COLUMNS = {
  MERCHANT: 'Merchant',
  REVENUE: 'Revenue',
  FEES: 'Fees',
  NET_EARNINGS: 'Net Earnings',
  ORDERS: 'Orders',
  ACTIONS: 'Actions',
} as const;

export const STAT_LABELS = {
  TOTAL_REVENUE: 'Total Revenue',
  TOTAL_FEES: 'Total Fees',
  NET_PAYOUTS_DUE: 'Net Payouts Due',
  TOTAL_ORDERS: 'Total Orders',
  ACROSS_MERCHANTS: (n: number) => `Across ${n} merchants`,
  OF_REVENUE: 'of revenue',
  AMOUNT_TO_PAY: 'Amount to pay merchants',
  AVG: (v: string) => `Avg: ${v}`,
} as const;

export const BUTTON_LABELS = {
  EXPORT_CSV: 'Export CSV',
  REFRESH: 'Refresh',
  VIEW: 'View',
  TRY_AGAIN: 'Try Again',
  GO_BACK: 'Go Back',
} as const;

export const MODAL_TITLE = (name: string) => `Merchant Details: ${name}`;
export const LOADING_DETAILS = 'Loading details…';
export const ERROR_LOADING_TITLE = 'Error Loading Data';
export const SEARCH_PLACEHOLDER = 'Search by name or email...';
export const PAGINATION_LABEL = (page: number, total: number, items: number) =>
  `Page ${page} of ${total} • ${items} items`;
export const PREVIOUS = 'Previous';
export const NEXT = 'Next';

export const PLATFORM_KIOSK = 'Kiosk';
export const PLATFORM_MOBILE = 'Mobile';
export const PLATFORM_BREAKDOWN_TITLE = 'Platform Breakdown';
export const REVENUE_LABEL = 'Revenue:';
export const FEES_LABEL = 'Fees:';
export const NET_LABEL = 'Net:';
export const ORDERS_LABEL = (n: number) => `${n} orders`;

export const EXPORT_FILENAME_PREFIX = 'merchants-earnings';
